var map = {
	"./5stars": 98724,
	"./5stars.svg": 98724,
	"./FB_on_sale_tag": 66612,
	"./FB_on_sale_tag.jpg": 66612,
	"./FB_on_sale_tag_2x": 17099,
	"./FB_on_sale_tag_2x.jpg": 17099,
	"./affirm_logo": 48325,
	"./affirm_logo.svg": 48325,
	"./arrow-dark-transparent": 77413,
	"./arrow-dark-transparent.svg": 77413,
	"./arrow-white-transparent": 66614,
	"./arrow-white-transparent.svg": 66614,
	"./arrow_bg_gray": 19275,
	"./arrow_bg_gray.svg": 19275,
	"./arrow_bg_light": 53138,
	"./arrow_bg_light.svg": 53138,
	"./arrow_bg_lightgray": 22663,
	"./arrow_bg_lightgray.svg": 22663,
	"./arrow_bg_pink": 18754,
	"./arrow_bg_pink.svg": 18754,
	"./arrow_left": 27385,
	"./arrow_left.svg": 27385,
	"./arrow_left_dark": 14080,
	"./arrow_left_dark.svg": 14080,
	"./arrow_left_white": 13187,
	"./arrow_left_white.svg": 13187,
	"./arrow_right": 49348,
	"./arrow_right.svg": 49348,
	"./arrow_right_dark": 72259,
	"./arrow_right_dark.svg": 72259,
	"./arrow_right_white": 5694,
	"./arrow_right_white.svg": 5694,
	"./arrow_whitebg_left": 39292,
	"./arrow_whitebg_left.svg": 39292,
	"./arrow_whitebg_right": 61091,
	"./arrow_whitebg_right.svg": 61091,
	"./badge-corner": 14717,
	"./badge-corner.svg": 14717,
	"./best-seller": 83258,
	"./best-seller.svg": 83258,
	"./bow": 34512,
	"./bow.svg": 34512,
	"./bread_icon": 61781,
	"./bread_icon.png": 61781,
	"./button_fb_continue": 8521,
	"./button_fb_continue.svg": 8521,
	"./cart": 84870,
	"./cart.svg": 84870,
	"./cart_black": 58322,
	"./cart_black.svg": 58322,
	"./cart_blue": 4761,
	"./cart_blue.svg": 4761,
	"./cc/amex_48": 92948,
	"./cc/amex_48.png": 92948,
	"./cc/discover_48": 3216,
	"./cc/discover_48.png": 3216,
	"./cc/master_48": 43073,
	"./cc/master_48.png": 43073,
	"./cc/paypal_48": 62236,
	"./cc/paypal_48.png": 62236,
	"./cc/visa_48": 61558,
	"./cc/visa_48.png": 61558,
	"./checkmark": 87711,
	"./checkmark.svg": 87711,
	"./checkout_countries/flag_au": 5122,
	"./checkout_countries/flag_au.jpg": 5122,
	"./checkout_countries/flag_ca": 98888,
	"./checkout_countries/flag_ca.jpg": 98888,
	"./checkout_countries/flag_eu": 99710,
	"./checkout_countries/flag_eu.jpg": 99710,
	"./checkout_countries/flag_gb": 22123,
	"./checkout_countries/flag_gb.jpg": 22123,
	"./checkout_countries/flag_us": 71832,
	"./checkout_countries/flag_us.jpg": 71832,
	"./close_black_thin": 39514,
	"./close_black_thin.svg": 39514,
	"./doublehearts": 65076,
	"./doublehearts.svg": 65076,
	"./doublehearts_bold": 37526,
	"./doublehearts_bold.svg": 37526,
	"./doublehearts_bold_black": 22850,
	"./doublehearts_bold_black.svg": 22850,
	"./doublehearts_pink": 50475,
	"./doublehearts_pink.svg": 50475,
	"./doublehearts_sale": 24454,
	"./doublehearts_sale.svg": 24454,
	"./dropdown-arrow": 55935,
	"./dropdown-arrow.svg": 55935,
	"./envelop-icon": 3451,
	"./envelop-icon.svg": 3451,
	"./extend_icon": 36612,
	"./extend_icon.svg": 36612,
	"./facebook": 4199,
	"./facebook.png": 4199,
	"./facebook_like": 74146,
	"./facebook_like.svg": 74146,
	"./filter_icon_blue": 81337,
	"./filter_icon_blue.svg": 81337,
	"./filter_icon_dark_purple": 20782,
	"./filter_icon_dark_purple.svg": 20782,
	"./flags/rd/canada": 9939,
	"./flags/rd/canada.svg": 9939,
	"./flip": 86029,
	"./flip.svg": 86029,
	"./generic_loading": 78026,
	"./generic_loading.gif": 78026,
	"./gift_primary_purple": 71070,
	"./gift_primary_purple.svg": 71070,
	"./hamburger": 51073,
	"./hamburger.svg": 51073,
	"./heart-clicked-v4": 5015,
	"./heart-clicked-v4.svg": 5015,
	"./heart-unclicked-v4": 37962,
	"./heart-unclicked-v4.svg": 37962,
	"./heart_filled_pink": 13218,
	"./heart_filled_pink.svg": 13218,
	"./heart_outline_black": 62859,
	"./heart_outline_black.svg": 62859,
	"./jewlr": 51352,
	"./jewlr-logo": 96323,
	"./jewlr-logo.png": 96323,
	"./jewlr.gif": 51352,
	"./jewlr_diamond": 96905,
	"./jewlr_diamond.jpg": 82090,
	"./jewlr_diamond.svg": 96905,
	"./jwl_diamond_blue": 31913,
	"./jwl_diamond_blue.svg": 31913,
	"./jwl_diamond_white": 76968,
	"./jwl_diamond_white.svg": 76968,
	"./loading_icon": 31364,
	"./loading_icon.gif": 31364,
	"./loading_iconA": 43053,
	"./loading_iconA.gif": 43053,
	"./made_in_ca": 27278,
	"./made_in_ca.svg": 27278,
	"./made_in_ca_white": 83327,
	"./made_in_ca_white.png": 83327,
	"./made_in_ca_white.svg": 11600,
	"./made_in_ca_white_desktop": 8249,
	"./made_in_ca_white_desktop.svg": 8249,
	"./made_in_ca_white_for_red_background": 79187,
	"./made_in_ca_white_for_red_background.svg": 79187,
	"./made_in_ca_white_mobile": 18397,
	"./made_in_ca_white_mobile.svg": 18397,
	"./maple_leaf_white": 47944,
	"./maple_leaf_white.svg": 47944,
	"./misc/question-mark": 97600,
	"./misc/question-mark.png": 97600,
	"./misc/spinner_full": 31814,
	"./misc/spinner_full.gif": 31814,
	"./mothers-delivery": 19097,
	"./mothers-delivery.svg": 19097,
	"./orders/change-order": 38013,
	"./orders/change-order.svg": 38013,
	"./orders/repair": 49497,
	"./orders/repair.svg": 49497,
	"./orders/resize": 71750,
	"./orders/resize.svg": 71750,
	"./orders/return": 33504,
	"./orders/return.svg": 33504,
	"./perks/99dayreturn": 23500,
	"./perks/99dayreturn.svg": 23500,
	"./perks/freegift": 60810,
	"./perks/freegift.svg": 60810,
	"./perks/freeresizing": 13753,
	"./perks/freeresizing.svg": 13753,
	"./perks/freeshipping": 11542,
	"./perks/freeshipping.svg": 11542,
	"./perks/madein": 68964,
	"./perks/madein.svg": 68964,
	"./perks/safe-shopping": 1150,
	"./perks/safe-shopping.svg": 1150,
	"./perks/warranty": 58278,
	"./perks/warranty.svg": 58278,
	"./photo_uploads/URL": 48821,
	"./photo_uploads/URL.svg": 48821,
	"./photo_uploads/delete": 32427,
	"./photo_uploads/delete.svg": 32427,
	"./photo_uploads/down": 88442,
	"./photo_uploads/down.svg": 88442,
	"./photo_uploads/dropbox": 16316,
	"./photo_uploads/dropbox.svg": 16316,
	"./photo_uploads/edit": 60038,
	"./photo_uploads/edit.svg": 60038,
	"./photo_uploads/facebook": 75318,
	"./photo_uploads/facebook.svg": 75318,
	"./photo_uploads/flickr": 54191,
	"./photo_uploads/flickr.svg": 54191,
	"./photo_uploads/googledrive_1x": 93240,
	"./photo_uploads/googledrive_1x.jpg": 93240,
	"./photo_uploads/googledrive_2x": 13065,
	"./photo_uploads/googledrive_2x.jpg": 13065,
	"./photo_uploads/instagram": 39485,
	"./photo_uploads/instagram.jpg": 39485,
	"./photo_uploads/instagram_2x": 78384,
	"./photo_uploads/instagram_2x.jpg": 78384,
	"./photo_uploads/left": 49393,
	"./photo_uploads/left.svg": 49393,
	"./photo_uploads/onclick/delete": 77055,
	"./photo_uploads/onclick/delete.svg": 77055,
	"./photo_uploads/onclick/down": 22862,
	"./photo_uploads/onclick/down.svg": 22862,
	"./photo_uploads/onclick/edit": 33490,
	"./photo_uploads/onclick/edit.svg": 33490,
	"./photo_uploads/onclick/left": 16133,
	"./photo_uploads/onclick/left.svg": 16133,
	"./photo_uploads/onclick/right": 95464,
	"./photo_uploads/onclick/right.svg": 95464,
	"./photo_uploads/onclick/rotate_left": 53837,
	"./photo_uploads/onclick/rotate_left.svg": 53837,
	"./photo_uploads/onclick/rotate_right": 81808,
	"./photo_uploads/onclick/rotate_right.svg": 81808,
	"./photo_uploads/onclick/up": 17445,
	"./photo_uploads/onclick/up.svg": 17445,
	"./photo_uploads/onclick/zoomin": 49278,
	"./photo_uploads/onclick/zoomin.svg": 49278,
	"./photo_uploads/onclick/zoomout": 7865,
	"./photo_uploads/onclick/zoomout.svg": 7865,
	"./photo_uploads/right": 41948,
	"./photo_uploads/right.svg": 41948,
	"./photo_uploads/rotate_left": 55161,
	"./photo_uploads/rotate_left.svg": 55161,
	"./photo_uploads/rotate_right": 51300,
	"./photo_uploads/rotate_right.svg": 51300,
	"./photo_uploads/up": 45257,
	"./photo_uploads/up.svg": 45257,
	"./photo_uploads/upload": 78089,
	"./photo_uploads/upload-arrow": 77453,
	"./photo_uploads/upload-arrow.svg": 77453,
	"./photo_uploads/upload.svg": 78089,
	"./photo_uploads/zoomin": 60330,
	"./photo_uploads/zoomin.svg": 60330,
	"./photo_uploads/zoomout": 21853,
	"./photo_uploads/zoomout.svg": 21853,
	"./quick_ship_green": 33190,
	"./quick_ship_green.svg": 33190,
	"./reseller_ratings": 89142,
	"./reseller_ratings.png": 89142,
	"./resize": 21788,
	"./resize.svg": 21788,
	"./ring-width-icons/10.5mm": 36989,
	"./ring-width-icons/10.5mm.svg": 36989,
	"./ring-width-icons/10mm": 74450,
	"./ring-width-icons/10mm.svg": 74450,
	"./ring-width-icons/11mm": 66327,
	"./ring-width-icons/11mm.svg": 66327,
	"./ring-width-icons/5.5mm": 9673,
	"./ring-width-icons/5.5mm.svg": 9673,
	"./ring-width-icons/5mm": 31998,
	"./ring-width-icons/5mm.svg": 31998,
	"./ring-width-icons/6.5mm": 38318,
	"./ring-width-icons/6.5mm.svg": 38318,
	"./ring-width-icons/6mm": 4197,
	"./ring-width-icons/6mm.svg": 4197,
	"./ring-width-icons/7.5mm": 5991,
	"./ring-width-icons/7.5mm.svg": 5991,
	"./ring-width-icons/7mm": 20584,
	"./ring-width-icons/7mm.svg": 20584,
	"./ring-width-icons/8.5mm": 65108,
	"./ring-width-icons/8.5mm.svg": 65108,
	"./ring-width-icons/8mm": 31135,
	"./ring-width-icons/8mm.svg": 31135,
	"./ring-width-icons/9.5mm": 22197,
	"./ring-width-icons/9.5mm.svg": 22197,
	"./ring-width-icons/9mm": 72986,
	"./ring-width-icons/9mm.svg": 72986,
	"./ring-width-icons/display": 77147,
	"./ring-width-icons/display.svg": 77147,
	"./seals/trustwave_seal": 46557,
	"./seals/trustwave_seal.png": 46557,
	"./search": 44568,
	"./search.svg": 44568,
	"./send-a-hint-icon": 10536,
	"./send-a-hint-icon.svg": 10536,
	"./spinner": 89507,
	"./spinner.gif": 89507,
	"./spinner_2x": 72820,
	"./spinner_2x.gif": 72820,
	"./touch/touch-icon-ipad": 90225,
	"./touch/touch-icon-ipad-retina": 749,
	"./touch/touch-icon-ipad-retina.png": 749,
	"./touch/touch-icon-ipad.png": 90225,
	"./touch/touch-icon-iphone": 37698,
	"./touch/touch-icon-iphone-retina": 8624,
	"./touch/touch-icon-iphone-retina.png": 8624,
	"./touch/touch-icon-iphone.png": 37698,
	"./tree": 84244,
	"./tree.svg": 84244,
	"./tree_black": 47632,
	"./tree_black.svg": 47632,
	"./truck": 57053,
	"./truck.svg": 57053,
	"./truck_primary_purple": 71947,
	"./truck_primary_purple.svg": 71947,
	"./upload-arrow": 9515,
	"./upload-arrow.svg": 9515,
	"./whatsapp_blue": 67625,
	"./whatsapp_blue.svg": 67625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68593;